import AjaxService from "services/base/Ajax.service";

class LocationService extends AjaxService {
  async getLocations() {
    return this.get("/location/");
  }

  async upsertLocation(data) {
    return this.post("/location/upsert", data);
  }

  async deleteLocation(locationId) {
    return this.delete(`/location/${locationId}/delete`);
  }
}

export default new LocationService();
